<div class="row row-sm add-form min">
    <div class="col-lg-12 ">
      <div class="card-body">
        <div class="bc d-flex align-items-center pl-3">
          <div class="ml-2">
            <h3 class="main-content-label mb-1"><b>
                Examinations Appeared
              </b></h3>
          </div>
        </div>
       
        <div class="row row-sm add-form">
            <h6>{{data.RgBatch}}   {{data.RgName}}</h6>
            <div class="col-sm-12 pl-0">
                <div>
                    <div class="table-responsive " id="table">
                        <table class="table table-bordered text-nowrap">
                            <thead>
                                <tr class="text-left">
                                    <th class="f600">
                                        Ex
                                    </th>
                                    <th class="f600">
                                        Code
                                    </th>
                                    <th class="f600">
                                        Session
                                    </th>
                                    <th class="f600">
                                        Attempt
                                    </th>
                                    <th class="f600">
                                        Result
                                    </th>
                                    <th class="f600">
                                        Marks
                                    </th>
                                    <th class="f600">
                                        OutOff
                                    </th>
                                    <th class="f600">
                                        Div
                                    </th>
                                    <th class="f600">
                                        Status
                                    </th>
                                    <th class="f600">
                                        RollNo
                                    </th>
                                    <th class="f600">
                                        GrpCode
                                    </th>
                                    <th class="f600">
                                        Credits
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="curs">
                                <tr *ngFor="let item of examData" [class.selected-row]="item === selectedRow" (click)="selected(item)">
                                    <td>{{item.ReEmSrNo}}</td>
                                    <td>{{item.EmCode}}</td>
                                    <td>{{item.ReSnName}}</td>
                                    <td>{{item.ReAttempt}}</td>
                                    <td>{{item.ReResult}}</td>
                                    <td>{{item.ReObtMarks}}</td>
                                    <td>{{item.ReMaxMarks}}</td>
                                    <td>{{item.ReDiv}}</td>
                                    <td>{{item.ReStatus}}</td>
                                    <td>{{item.ReRollNo}}</td>
                                    <td>{{item.ReGP_CR}}</td>
                                    <td>{{item.ReCredits}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row">
            <div class="col-sm-8"></div>
           
                <div class="col-sm-4">
                    <button type="button" 
                class="btn fr sz btn-primary floatright btn-icon-text ml-5  mt-2" (click)="openSub()">Sub</button>
              
                    <button type="button" [mat-dialog-close]="true"
                    class="btn btn-primary btn-icon-text mr-5 floatright mt-2">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/list.gif"
                            style="margin-right: 7px;">
                        List
                    </span>
                </button>
                </div>
              
            </div>
            
        </div>
      </div>
    </div>
  </div>